var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca-phone-icon_svg__clip0_1069_10440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.666 12.016v2a1.334 1.334 0 01-1.453 1.333 13.193 13.193 0 01-5.753-2.046 13 13 0 01-4-4 13.193 13.193 0 01-2.047-5.78A1.333 1.333 0 012.74 2.069h2a1.333 1.333 0 011.333 1.147A8.56 8.56 0 006.54 5.09a1.333 1.333 0 01-.3 1.407l-.847.847a10.666 10.666 0 004 4l.847-.847a1.333 1.333 0 011.406-.3 8.557 8.557 0 001.874.467 1.333 1.333 0 011.146 1.353z",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ca-phone-icon_svg__clip0_1069_10440"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .736)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/ca-phone-icon.f4275712.svg";
export { SvgCaPhoneIcon as ReactComponent };